import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../layout/BackButton.css';

// BackToLotLink is shown on an Animals tab opened from a lot's "Animals" row
// (LotDetail passes the lot as location.state.lotFilter), so the list reads as
// "this lot's animals" and the lot is one tap away, even after a refresh.
const BackToLotLink = ({ lotId, prefix, basePath }) => {
  const navigate = useNavigate();
  if (lotId == null) return null;
  return (
    <button className="back-button" onClick={() => navigate(`${basePath}/${lotId}`)}
      data-testid="back-to-lot">
      ← {prefix}-{String(lotId).padStart(4, '0')}
    </button>
  );
};

export default BackToLotLink;
